import { Button, YoutubeIcon } from 'components/atoms';
import { useStoreState } from 'providers/StoreStateContext';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { PiCaretDownBold, PiPowerBold } from 'react-icons/pi';
import { useLocation, useNavigate } from 'react-router-dom';
import { BUTTON_VARIANT } from 'types/components/button/button.interface';
import { INavbarItem } from 'types/navbar/navbar.interface';
import { getParentPathname } from 'utils/navbar/getParentPathname';
import { navbarItems } from 'utils/navbar/navbarItems';
import './Navbar.scss';

const Navbar = () => {
  const [showChildren, setShowChildren] = useState<Record<string, boolean>>({});
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const { t } = useTranslation();
  const { clearTokens, tokenData } = useStoreState();

  const customStyle = { justifyContent: 'start' };

  const isPageActive = (name: string): boolean =>
    getParentPathname(pathname) === name;

  const toggleChildren = (key: string) => {
    setShowChildren(prev => ({ [key]: !prev[key] }));
    // setShowChildren(prev => ({ ...prev, [key]: !prev[key] }));
  };

  const navigateToPath = (item: INavbarItem, key: string) => {
    if (item.children) {
      toggleChildren(key);
      if (showChildren[key]) {
        return;
      }
    }
    navigate(`/${item.path}`);
  };

  return (
    <div className='navbar-wrapper'>
      <div className='buttons'>
        {navbarItems.map((item, key) => (
          <div
            key={key}
            className={`button-wrapper ${
              showChildren[key] ? 'show-sub-menu' : ''
            }`}>
            <Button
              isClear
              buttonStyle={customStyle}
              fullWidth
              isActive={
                item.children?.length
                  ? !!item.children.find(({ path }) => isPageActive(path))
                  : isPageActive(item.path)
              }
              onClick={() => navigateToPath(item, key.toString())}
              className='button'>
              <Button.Icon icon={<item.icon />} />
              <Button.Text text={t(`navbar.${item.name ?? item.path}`)} />

              {item.children && (
                <Button.Icon
                  icon={<PiCaretDownBold className='menu-arrow' />}
                />
              )}
            </Button>
            {item.children && (
              <div className={`sub-menu`}>
                {item.children.map((child, childKey) =>
                  child.permissionNames &&
                  tokenData &&
                  !child.permissionNames?.find(
                    name => tokenData[name as keyof typeof tokenData]
                  ) ? null : (
                    <Button
                      key={childKey}
                      isClear
                      size='compact'
                      buttonStyle={customStyle}
                      fullWidth
                      variant={
                        isPageActive(child.path) && child.path === 'channel'
                          ? BUTTON_VARIANT.remove
                          : undefined
                      }
                      isActive={
                        child.path === 'channel'
                          ? false
                          : isPageActive(child.path)
                      }
                      onClick={() => navigate(`/${child.path}`)}
                      className='button'>
                      <Button.Icon
                        icon={
                          child.path === 'channel' ? (
                            <YoutubeIcon />
                          ) : (
                            <child.icon />
                          )
                        }
                      />
                      <Button.Text
                        text={t(`navbar.${child.name ?? child.path}`)}
                      />
                    </Button>
                  )
                )}
              </div>
            )}
          </div>
        ))}
      </div>
      <div className='footer'>
        <div className='footer-buttons'>
          {/* <Button
            variant={BUTTON_VARIANT.default}
            fullWidth
            isClear
            onClick={() => navigate('/settings')}>
            <Button.Icon icon={<PiGearBold />} />
            <Button.Text text={t('navbar.settings')} />
          </Button> */}
          <Button
            variant={BUTTON_VARIANT.default}
            fullWidth
            onClick={clearTokens}>
            <Button.Icon icon={<PiPowerBold />} />
            <Button.Text text={t('navbar.logout')} />
          </Button>
        </div>
        <div className='footer-version'>MagelUP Admin Panel</div>
      </div>
    </div>
  );
};

export default Navbar;
